import React from "react";
import PostInternships from "../../Administrative/PostInternships";

const PostYuvasarthiInternships = () => {
  return (
    <div>
      <PostInternships role="Super Admin" />
    </div>
  );
};

export default PostYuvasarthiInternships;
